module.exports = __webpack_public_path__ + "u14.no2.9f86e620.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/u14.no2.jpg
// module id = kUan
// module chunks = 0